<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0"> اطلاعات مشتری های شماره نامه '{{inner_Letter.code}}' </h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="openModal_Customer(templateCustomer)" class="btn btn-success" style="margin-left: 5px;"> جستجوی مشتری
          <i class="fa fa-vcard"></i> </button>
          <button (click)="OnSet_Back_LetterrequestcustomerRelativeList()" type="button" class="btn btn-warning"><i
            class="fa fa-mail-reply"></i>
          بازگشت </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام مشتری</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterrequestcustomerRelative
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList_LetterrequestcustomerRelative.length
                      }
            ">
              <td>{{DataList_LetterrequestcustomerRelative.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>
                <button type="button" (click)="DeleteData(item)" class="btn btn-danger"> حذف
                  <i class="fa fa-remove"></i> </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>



<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات مشتری </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد مشتری بهفا</th>
              <th>نام مشتری</th>
              <th>نام مشتری (انگلیسی)</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td>{{item.name_en}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>
